import { useContext } from 'react';

import { addYears, isBefore } from 'date-fns';

import { Alert, Anchor, Spacer } from '@zillow/constellation';
import { Text } from '@zillow/constellation-10';

import { RMWContext } from '../../../providers/RMWContext';

import { PropertiesSelectors } from '../../../selectors';
import { useSelector } from '../../../selectors/useSelector';

const ListingRouteBackBanner = () => {
  const { paths } = useContext(RMWContext);

  const {
    dateCreated,
    multiToSingleFamilyConversion: { convertedFromListingAlias },
  } = useSelector((state) => PropertiesSelectors.makeCurrentProperty(state));

  const showListingRouteBackBanner =
    convertedFromListingAlias && isBefore(new Date(), addYears(new Date(dateCreated), 1));

  const handleAnchorClick = (event: KeyboardEvent & HTMLAnchorElement) => {
    const openNewTab = event.ctrlKey || event.metaKey;
    event.preventDefault();
    event.stopPropagation();

    const pathToRoute = `${paths.propertiesPage}/${convertedFromListingAlias}/listing`;

    if (openNewTab) {
      window.router.updateLocation(pathToRoute, '_blank');
    } else {
      window.router.transitionTo(pathToRoute);
    }
  };

  const body = (
    <Text>
      View the previous version of this&nbsp;
      <Anchor onClick={handleAnchorClick}>listing</Anchor>.
    </Text>
  );

  return showListingRouteBackBanner ? (
    <Spacer marginBottom="md">
      <Alert appearance="info" body={body} />
    </Spacer>
  ) : null;
};

export default ListingRouteBackBanner;
